(function () {
  'use strict';

  const lineMarkup = '<svg width="587" height="35" viewBox="0 0 587 35" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 25C10 25 414.654 -8.7499 577 25" stroke="currentColor" stroke-width="20" stroke-linecap="round" preserveAspectRatio="none" />' +
    '</svg>';

  const spacialUnderlineMarkup = '<svg' +
    '  viewBox="0 0 587 35"' +
    '  preserveAspectRatio="none"' +
    '  xmlns="http://www.w3.org/2000/svg"' +
    '>' +
    '  <path' +
    '    d="M 2.028 24.275 C 2.028 24.275 425.218 14.863 586.181 18.719"' +
    '    stroke="currentColor"' +
    '    stroke-width="20"' +
    '    fill="none"' +
    '  />' +
    '</svg>';

  class HighlightText {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.texts.length; i++) {
        const text = this.DOM.texts[i];
        const isEnabled = text.dataset.enabled === '' ? true : false;

        if (isEnabled) {
          const variant = text.dataset.style;
          const color = text.dataset.color;
          const label = text.dataset.label;
          const ems = text.querySelectorAll('em');

          if (ems.length) {
            for (let j = 0; j < ems.length; j++) {
              const em = ems[j];
              const emText = em.innerHTML;
              const span = document.createElement('span');

              span.className = 'highlight-text__item highlight-text__item--' + variant;
              span.style.setProperty('--highlight-text-color', color);
              span.innerHTML = emText;

              if (variant === 'two') {
                const line = document.createElement('span');
                line.className = 'highlight-text__item-line js-highlight-text-line';
                line.setAttribute('aria-hidden', 'true');
                line.innerHTML = lineMarkup;
                span.appendChild(line);
              } else if (variant === 'four') {
                const line = document.createElement('span');
                line.className = 'highlight-text__item-underline js-highlight-text-line';
                line.setAttribute('aria-hidden', 'true');
                line.innerHTML = spacialUnderlineMarkup;
                span.appendChild(line);
              } else if (variant === 'live') {
                const dot = document.createElement('span');
                dot.className = 'highlight-text__item-dot';
                dot.setAttribute('aria-hidden', 'true');
                span.appendChild(dot);
              } else if (variant === 'label' && label) {
                const badge = document.createElement('span');
                badge.className = 'highlight-text__item-label';
                badge.textContent = label;
                span.appendChild(badge);
              }

              em.parentNode.replaceChild(span, em);
            }
          }
        }
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      if (sectionEl.querySelector('.js-highlight-text')) {
        this.reinit();
      }
    }

    destroy() {
      if (this.DOM) {
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const texts = container.querySelectorAll('.js-highlight-text');

      if (texts.length) {
        this.DOM = {};
        this.DOM.texts = texts;

        this.setup();
      }
    }
  }

  window.Universe.HighlightText = HighlightText;
})();
